module.exports = __webpack_public_path__ + "media/St 4-phone-tablet-hint.793589e1.wav";